import { Download, FileSpreadsheet } from 'lucide-react';
import { Button } from '../../ui/button';

export function ExportButtons({ onExportTrackAnalytics, onExportRoyaltyHistory }) {
  return (
    <div className="flex gap-3">
      <Button
        onClick={onExportTrackAnalytics}
        variant="outline"
        className="border-purple-500/50 text-purple-400 hover:bg-purple-500/20"
        data-testid="export-track-btn"
      >
        <Download className="w-4 h-4 mr-2" />
        Export Track Analytics
      </Button>
      <Button
        onClick={onExportRoyaltyHistory}
        variant="outline"
        className="border-green-500/50 text-green-400 hover:bg-green-500/20"
        data-testid="export-royalty-btn"
      >
        <FileSpreadsheet className="w-4 h-4 mr-2" />
        Export Royalty History
      </Button>
    </div>
  );
}
